<template>
  <div style="display: inline-block;">
    <img class="img-icon" v-if="iconClass == 'icon-user-guest'" src="../../assets/img/35.png" alt="">
    <img class="img-icon" v-if="iconClass == 'icon-user-seat'" src="../../assets/img/14.png" alt="">
    <img class="img-icon" v-if="iconClass == 'icon-user-gzlog'" src="../../assets/img/33.png" alt="">
    <img class="img-icon" v-if="iconClass == 'icon-user-info'" src="../../assets/img/27.png" alt="">
<!--    <img class="img-icon" v-if="iconClass == 'icon-user-info'" src="../../assets/img/公告列表.png" alt="">-->
    <template v-if="iconClass !='icon-user-guest' && iconClass !='icon-user-seat' && iconClass !='icon-user-gzlog' && iconClass !='icon-user-info'">
      <svg :class="svgClass" aria-hidden="true" v-on="$listeners">
        <use :href="iconName"/>
      </svg>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'SvgIcon',
    props: {
      iconClass: {
        type: String,
        required: true
      },
      className: {
        type: String,
        default: ''
      }
    },
    computed: {
      iconName() {
        if(this.iconClass == 'icon-user-guest' || this.iconClass == 'icon-user-seat' || this.iconClass == 'icon-user-gzlog' || this.iconClass == 'icon-user-info'){
          return this.iconClass
        }else{
          return `#icon-${this.iconClass}`
        }
        // return this.iconClass
      },
      svgClass() {
        if (this.className) {
          return 'svg-icon ' + this.className
        } else {
          return 'svg-icon'
        }
      }
    }
  }
</script>

<style scoped>
  .img-icon{
    width: 20px;
    height: 23px;
  }
  .svg-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }

  .svg-external-icon {
    background-color: currentColor;
    mask-size: cover !important;
    display: inline-block;
  }
</style>
